import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {SettingsHeader} from '../settingsHeader';

/*
 * Component.
 */

export const SettingsPreferencesHeader: FC = () => (
  <SettingsHeader>
    <Trans id="settings-preferences-header">Preferences</Trans>
  </SettingsHeader>
);
